import { render } from "./RequestsListItem.vue?vue&type=template&id=39b3332c&scoped=true"
import script from "./RequestsListItem.vue?vue&type=script&lang=js"
export * from "./RequestsListItem.vue?vue&type=script&lang=js"

import "./RequestsListItem.vue?vue&type=style&index=0&id=39b3332c&scoped=true&lang=css"

import exportComponent from "/Users/klausdresbach/Dropbox/IT-Projekte/Web-Entwicklung/niceplaces/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39b3332c"]])

export default __exports__